import { createContext, useState } from 'react';
import { IUser } from '../interfaces/user';

type TStatus =
    | 'newuser'
    | 'inprogress'
    | 'validated'
    | 'connected'
    | 'disconnected';

interface IStateUser {
    user: IUser;
    tokenRC: string;
    status: TStatus;
    isLoading: boolean;
    snackBar: string;
    createUser: Function;
    verifyTokenRC: Function;
    changeNewUser: Function;
    changeIsLoading: Function;
    changeSnackBar: Function;
}

interface IAppContext {
    children: any;
}

const initUser: IUser = {
    name: '',
    lastName: '',
    position: '',
    email: '',
    phone: '',
};

const initialState: IStateUser = {
    user: initUser,
    tokenRC: '',
    status: 'newuser',
    isLoading: false,
    snackBar: '',
    createUser: () => {},
    verifyTokenRC: () => {},
    changeNewUser: () => {},
    changeIsLoading: () => {},
    changeSnackBar: () => {},
};

const AppContext = createContext(initialState);

const AppContextProvider = ({ children }: IAppContext) => {
    let [user, setUser] = useState<IUser>(initUser);
    let [tokenRC, setTokenRC] = useState<string>('');
    let [status, setStatus] = useState<TStatus>('newuser');
    let [isLoading, setIsLoading] = useState<boolean>(false);
    let [snackBar, setSnackBar] = useState<string>('');

    const createUser = (u: IUser) => {
        setUser(u);
    };

    const verifyTokenRC = async (t: string) => {
        setTokenRC(t);
    };

    const changeNewUser = async (s: TStatus) => {
        setStatus(s);
    };

    const changeIsLoading = (l: boolean) => {
        setIsLoading(l);
    };

    const changeSnackBar = (sn: string) => {
        setSnackBar(sn);
    };

    return (
        <AppContext.Provider
            value={{
                user,
                tokenRC,
                status,
                isLoading,
                snackBar,
                createUser,
                verifyTokenRC,
                changeNewUser,
                changeIsLoading,
                changeSnackBar,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export { AppContext, AppContextProvider };
